import { GLOBAL } from '@/store/types'
import utils from '@/utils/utils.js'
import EventBus from 'login/EventBus'
import storage from '@/utils/storage'
import bookingService from '@/api/booking'

const Global = {
  namespaced: true,
  state: {
    clientDomains: [],
    originalRoomsQuota: 0,
    locations: [],
    equipments: [],
    rooms: [],
    locationMap: {},
    equipmentMap: {},
    roomMap: {},
    company: window.location.host.substring(0, window.location.host.indexOf('.')) || 'default',
    windowWidth: 0,
    initialSettings: {
      domains: [],
      rooms: {
        roomsQuota: 0,
        combinedRoomsQuota: 0,
        occurrencesLimit: 0
      }
    },
    touchDevice: (typeof window.orientation !== 'undefined'),
    touchUsed: false,
  },
  getters: {
    locations(state) {
      return state.locations
    },
    locationMap(state) {
      return state.locationMap
    },
    equipments(state) {
      return state.equipments
    },
    windowWidth(state) {
      return state.windowWidth
    },
    uiConfiguration(state) {
      return state.uiConfiguration
    },
    roomsQuota(state) {
      return state.initialSettings.rooms.roomsQuota
    },
    combinedRoomsQuota(state) {
      return state.initialSettings.rooms.combinedRoomsQuota
    },
    occurrencesLimit(state) {
      return state.initialSettings.rooms.occurrencesLimit
    },
    roomMap(state) {
      return state.roomMap
    },
    touchDevice(state) {
      return state.touchDevice
    },
    isMobile(state) {
      return state.windowWidth <= 960
    },
    isLargeScreen(state) {
      return state.windowWidth > 1279
    },
    activeAutoCompleteMailBox(state) {
      return state.initialSettings.rooms.activeAutoCompleteMailBox
    },
    isServiceDeskEnabled(state) {
      return state.initialSettings.rooms.isServiceDeskEnabled
    },
    domains(state) {
      return state.initialSettings.domains
    },
    showSettings: (state) => {
      if (state.initialSettings.user.meetingSpace.favoriteLocationId === null) {
        return true
      } else if (state.initialSettings.user.meetingSpace.pin === null && state.initialSettings.rooms.hasPinCheckIn) {
        return true
      } else if (state.initialSettings.user.costCenter === null && state.initialSettings.hasCostCenter) {
        return true
      } else {
        return false
      }
    }
  },
  mutations: {
    [GLOBAL.SET_WINDOW_WIDTH](state, value) {
      state.windowWidth = value
    },
    [GLOBAL.SET_COMPANY_DATA](state, value) {
      state.initialSettings = value.settings

      state.locations = value.locations
      state.equipments = value.equipments
      state.rooms = value.rooms
      state.rooms.forEach((room) => {
        room.showEvents = false
      })
      state.locationMap = value.locationMap
      state.equipmentMap = value.equipmentMap
      state.roomMap = value.roomMap
    },
    [GLOBAL.SET_TOUCH_USED](state, value) {
      state.touchUsed = value
    },
    [GLOBAL.SET_CLIENT_QUOTA](state, value) {
      state.initialSetting.rooms.combinedRoomsQuota = value.combinedRoomsQuota
      state.initialSetting.rooms.roomsQuota = value.roomsQuota
    },
    [GLOBAL.SET_CLIENT_UI_CONFIGURATION](state, uiConfiguration) {
      state.uiConfiguration = uiConfiguration
    }
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    showMessage({ }, obj) {
      EventBus.publish("setMessage", obj)
    },
    // eslint-disable-next-line no-empty-pattern
    showLoading({ }) {
      EventBus.publish("showLoading")
    },
    // eslint-disable-next-line no-empty-pattern
    hideLoading({ }) {
      EventBus.publish("hideLoading")
    },
    setWindowWidth({ commit }, value) {
      commit(GLOBAL.SET_WINDOW_WIDTH, value)
    },
    setTouchUsed({ commit }) {
      commit(GLOBAL.SET_TOUCH_USED, true)
    },
    // eslint-disable-next-line no-empty-pattern
    getInitialSettings: function ({ }) {
      EventBus.publish("getInitialSettings")
    },
    async updateInitialSettings({ commit, state, dispatch }) {
      let settings = storage.getFromLocalStorage('settings')
      await bookingService.getSiteData(settings.meetingSpaceId).then((response) => {
        let company = response.data
        let locationMap = utils._map(company.locations)
        let equipmentMap = utils._map(company.equipments)
        let roomMap = utils._map(company.rooms)

        company.locations.sort((a, b) => {
          var x = a.locationName.toLowerCase()
          var y = b.locationName.toLowerCase()
          if (x < y) {
            return -1
          } else
            if (x > y) {
              return 1
            } else {
              return 0
            }
        })

        // carrega listas aninhadas
        for (var location of company.locations) {
          location.rooms = []
          if (location.roomIds) {
            for (var roomId of location.roomIds) {
              var room = roomMap[roomId]
              if (room) {
                location.rooms.push(room)
                room.equipments = []
                room.location = location
                if (room.avaliableEquipmentsIds) {
                  for (var equipmentId of room.avaliableEquipmentsIds) {
                    var equipment = equipmentMap[equipmentId]
                    room.equipments.push(equipment)
                  }
                }
              }
            }
          }
        }
        commit(GLOBAL.SET_COMPANY_DATA, {
          settings: settings,
          equipments: company.equipments,
          locations: company.locations,
          rooms: company.rooms,
          locationMap,
          equipmentMap,
          roomMap
        })

      }).finally(() => {
        dispatch('hideLoading', null)
      }
      )

      commit('Booking/SET_LOCATION_SELECTED', [], { root: true })

      if (state.initialSettings.user.meetingSpace.favoriteLocationId !== null) {
        commit('Booking/SET_LOCATION_SELECTED', [state.initialSettings.user.meetingSpace.favoriteLocationId], { root: true })
      }
    },
    getEquipment({ state }, id) {
      return state.equipmentMap[id]
    },
    setRoomsQuota({ commit }, value) {
      commit(GLOBAL.SET_CLIENT_QUOTA, value)
    },
    setUiConfiguration({ commit }, uiConfiguration) {
      commit(GLOBAL.SET_CLIENT_UI_CONFIGURATION, uiConfiguration)
    }
  }
}

export default Global
